import React, { useState } from "react";
import { handlePostRequest } from "../../services/PostTemplate";
import { Button } from "primereact/button";

function RefreshTitle({ fileStausData }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");

    const onSubmit = async () => {
        try {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            const fileDetailIds = fileStausData.map((item) => item.fileDetailId);
            await handlePostRequest({ fileDetails: fileDetailIds }, "zbizgateway/customerFileUpload/refreshTitleFetch");
        } catch (err) {
            console.log(err);
        } finally {
            setloading(false);
            setloadingIcon("pi pi-save");
        }
    };

    if (fileStausData == null || fileStausData.length === 0) {
        return null;
    }

    return (
        <>
            <div className="p-mb-4 Down__Btn">
                <Button onClick={onSubmit} disabled={loading} type="submit" icon={loadingIcon || ""} iconPos="right" label={"Refresh Title Fetch"} className="Btn__Dark" />
            </div>
        </>
    );
}

export default RefreshTitle;
